import { types } from '../reducers/sessionReducer';

// eslint-disable-next-line import/prefer-default-export
export const createSession = (values) => ({
  type: types.POST,
  payload: values,
});

export const updateSession = (values) => ({
  type: types.PUT,
  payload: values,
});

export const removeSession = (item) => ({
  type: types.DELETE,
  payload: item,
});

export const resetSession = () => ({
  type: types.RESET,
});
